import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'wlm-text-editor-type',
  templateUrl: './text-editor-type.component.html',
  styleUrl: './text-editor-type.component.scss',
  standalone: false,
})
export class TextEditorTypeComponent extends FieldType<FieldTypeConfig> {
  quillModules: {};
  editorWidth?: string;
  editorHeight?: string;

  ngOnInit() {
    if (this.props.quillModules) {
      this.quillModules = this.props.quillModules;
    }
    if (this.props.width) {
      this.editorWidth = this.props.width;
    }
    if (this.props.height) {
      this.editorHeight = this.props.height;
    }
  }
}
